export default "__VITE_ASSET__DQIu73y2__"